<template>
  <!-- Footer -->
  <mdb-footer
    v-if="!isAdmin"
    class="font-small footer footer-wrapper main-bg"
    :style="setMargin"
  >
    <mdb-container class="text-center text-md-left">
      <mdb-row
        :class="[
          'menu text-left text-md-left pt-2',
          { 'w-80 ml-5': !isMobile },
        ]"
      >
        <mdb-col
          :class="[
            'mt-3 col-4 col-md-2 mx-0',
            { 'col-5 col-md-3 ml-4': !isLogin },
          ]"
        >
          <h6 class="text-uppercase mb-4 font-weight-bold">メニュー</h6>
          <div v-if="isLogin">
            <p><b-link to="/home">ホーム</b-link></p>
            <p><b-link to="/trial">料金・納期</b-link></p>
            <p><b-link @click="checkYoshin">発注</b-link></p>
          </div>
          <div v-else>
            <p><b-link to="/">TOP</b-link></p>
            <p><b-link to="/password">パスワードリマインダー</b-link></p>
          </div>
        </mdb-col>
        <mdb-col
          v-if="isLogin"
          md="2"
          lg="2"
          xl="2"
          class="mt-3 col-3 mx-0 pl-0 pr-2"
        >
          <h6 class="text-uppercase mb-4 font-weight-bold">&nbsp;</h6>
          <p><b-link to="/history">発注履歴</b-link></p>
          <p><b-link to="/setting">設定</b-link></p>
          <p><b-link to="/inquiry">お問い合わせ</b-link></p>
        </mdb-col>
        <mdb-col v-if="!isMobile" md="5" class="mx-auto mt-3">
          <h6 class="text-uppercase mb-4">
            ロジNAVI利用マニュアル
            <br />
            （
            <a
              href="https://www.logi-co.co.jp/blog/wp-content/uploads/LOGINAVI_Manual_PC.pdf"
              target="_blank"
            >
              WEB版
            </a>
            |
            <a
              href="https://www.logi-co.co.jp/blog/wp-content/uploads/LOGINAVI_Manual_SP.pdf"
              target="_blank"
            >
              スマートフォン版
            </a>
            ）
          </h6>
        </mdb-col>
        <mdb-col
          md="4"
          lg="3"
          xl="3"
          :class="['mt-3 col-5 mx-0 pr-2 pl-4', { 'ml-3': !isLogin }]"
        >
          <h6 class="text-uppercase mb-4 font-weight-bold">規約</h6>
          <p>
            <a
              href="https://www.logi-co.co.jp/service/rules.pdf"
              target="_blank"
            >
              輸送規約
            </a>
          </p>
          <p><a href="/kiyaku">サイト利用規約</a></p>
          <p>
            <a
              href="https://www.logi-co.co.jp/aboutus/disclaimer.html"
              target="_blank"
            >
              免責事項
            </a>
          </p>
          <p>
            <a
              href="https://www.logi-co.co.jp/aboutus/privacy.html"
              target="_blank"
            >
              個人情報保護方針
            </a>
          </p>
        </mdb-col>
      </mdb-row>
      <h6 v-if="isMobile" class="text-uppercase pt-5 mb-0">
        ロジNAVI利用マニュアル
        <br />
        （
        <a
          href="https://www.logi-co.co.jp/blog/wp-content/uploads/LOGINAVI_Manual_PC.pdf"
          target="_blank"
        >
          WEB版
        </a>
        |
        <a
          href="https://www.logi-co.co.jp/blog/wp-content/uploads/LOGINAVI_Manual_SP.pdf"
          target="_blank"
        >
          スマートフォン版
        </a>
        ）
      </h6>
      <hr />
      <!--<Banner />-->
      <mdb-row class="d-flex align-items-center">
        <mdb-col md="" lg="" class="parent">
          <p
            class="copyright text-center text-md-center grey-text f-size-10 children"
          >
            &copy; 2019 logico inc.
          </p>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      :md-active.sync="isYoshiFukaModal"
      md-title=""
      :md-content="getHcbApiErrorMessage('untrust')"
      md-confirm-text="問い合わせる"
      md-cancel-text="キャンセル"
      :md-click-outside-to-close="true"
      @md-confirm="gotoInquiry"
    />
  </mdb-footer>
  <!-- Footer -->
</template>
<script>
import Mixin from './mixin/Mixin'
import Banner from '@/components/Banner'
import { mdbFooter, mdbContainer, mdbRow, mdbCol } from 'mdbvue'
export default {
  name: 'FooterPage',
  mixins: [Mixin],
  props: {
    isLowHeight: Boolean,
  },
  components: {
    mdbFooter,
    mdbContainer,
    mdbRow,
    mdbCol,
    Banner,
  },
  data: () => ({
    isYoshiFukaModal: false, // 与信不可モーダル表示フラグ
  }),
  methods: {
    /**
     * 与信不可か確認し不可の場合はアラートを表示
     * 問題ない場合は発注画面に遷移する
     */
    checkYoshin() {
      if (this.isYoshinFuka) this.isYoshiFukaModal = true
      else this.$router.push({ name: 'OrderIndex' })
    },
  },
  computed: {
    setMargin() {
      // const path = this.$router.history.current.name
      // if (path === 'OrderComplete' || path === 'OrderMeihenComplete') {
      //  return 'margin-top: 3rem !important'
      // }
      return this.isLogin
        ? 'margin-top:0 !important'
        : 'margin-top: 3rem !important'
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../assets/css/logico2'
.footer-wrapper
  background: $baseBlueColor
.menu h6
  margin-bottom: 0.5em !important
hr
  margin: 1em
p
  line-height: 17px
  margin-bottom: 10px
a,i
  font-size: 15px
  color: white !important
  @include sp
    font-size: 13px
.copyright
  width: 100%
.parent
  position: relative
  height: 120px
  @include sp
    max-height: 40px
//子要素
.children
  position: absolute
  width: 95%
  bottom: 0
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue